import { ReactNode } from "react";

interface SearchInputProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  width?: string | number;
}

function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  className = "",
  width,
}: SearchInputProps) {
  return (
    <div
      className={`ctpl-search ${className}`}
      style={width ? { width } : undefined}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </div>
  );
}

export default SearchInput;